import "@scss/search-v2.scss";
import { initReactRootAppOnDOMContentLoaded } from "@ts/common/helper/initReactApp";
import { BrowseApp, initClickBridge } from "@ts/common/navigation/BrowseRouter";
initReactRootAppOnDOMContentLoaded(BrowseApp);
initClickBridge();
